export default [
  [
    {
      label: 'ใบสั่งรถบรรทุก',
      id: 'shippingOrdertext',
      type: 8,
      span: 24,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ใบสั่งรถบรรทุก' } },
    }, {
      label: 'Ref ID',
      id: 'shippingCode',
      type: 2,
      span: 8,
      offset: 0,
      margin: '0 0 40px 0',
      props: { padding: '8px 0', width: '100%', title: { text: 'Ref ID' } },
    }, {
      label: 'เล่มที่',
      id: 'shippingVolume',
      direction: 'column',
      type: 2,
      span: 4,
      offset: 4,
      props: { padding: '8px 0', width: '100%', title: { text: 'เล่มที่' } },
    }, {
      label: 'เลขที่',
      id: 'shippingNumber',
      direction: 'column',
      type: 2,
      span: 4,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'เลขที่' } },
    }, {
      label: 'วันที่สร้าง',
      id: 'startTime',
      direction: 'column',
      dataType: 'date',
      type: 2,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'วันที่สร้าง' } },
    }, {
      label: 'วันที่ครบกำหนด',
      id: 'assignDate',
      direction: 'column',
      dataType: 'date',
      type: 2,
      span: 8,
      offset: 4,
      props: { padding: '8px 0', width: '100%', title: { text: 'วันที่ครบกำหนด' } },
    },
  ], [
    {
      label: 'สัญญางาน',
      id: 'jobtext',
      type: 8,
      span: 24,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'สัญญางาน' } },
    }, {
      label: 'Ref ID',
      id: 'jobCode',
      type: 2,
      span: 8,
      offset: 0,
      margin: '0 0 40px 0',
      props: { padding: '8px 0', width: '100%', title: { text: 'Ref ID' } },
    }, {
      label: 'เล่มที่',
      id: 'jobVolume',
      direction: 'column',
      type: 2,
      span: 4,
      offset: 4,
      props: { padding: '8px 0', width: '100%', title: { text: 'เล่มที่' } },
    }, {
      label: 'เลขที่',
      id: 'jobNumber',
      direction: 'column',
      type: 2,
      span: 4,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'เลขที่' } },
    }, {
      label: 'ผู้จ้าง',
      id: 'customerCompanyName',
      type: 19,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ผู้จ้าง' } },
    }, {
      label: 'ประเภทผู้จ้าง',
      id: 'type',
      direction: 'column',
      type: 2,
      span: 4,
      offset: 4,
      props: { padding: '8px 0', width: '100%', title: { text: 'ประเภทผู้จ้าง' } },
    }, {
      label: 'ประเภทสัญญางาน',
      id: 'jobDealType',
      direction: 'column',
      type: 2,
      span: 4,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ประเภทสัญญางาน' } },
    },
  ], [
    {
      label: 'เดินทาง',
      id: 'travel',
      type: 8,
      span: 24,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'เดินทาง' } },
    }, {
      label: 'ขนจาก (ต้นทาง)',
      id: 'startLocation',
      type: 20,
      span: 12,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ขนจาก (ต้นทาง)' } },
    }, {
      label: 'ขนไป (ต้นทาง)',
      id: 'endLocation',
      type: 20,
      span: 12,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ขนไป (ต้นทาง)' } },
    },
  ], [
    {
      label: 'รถ และ พนักงาน',
      id: 'truckanddriver',
      type: 8,
      span: 24,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'รถ และ พนักงาน' } },
    }, {
      label: 'ทะเบียนรถ',
      id: 'plateNumber',
      direction: 'column',
      type: 2,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ทะเบียนรถ' } },
    }, {
      label: 'ชนิดรถ',
      id: 'truckType',
      direction: 'column',
      type: 2,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ชนิดรถ' } },
    }, {
      label: 'ประเภทรถ',
      id: 'truckCategory',
      direction: 'column',
      type: 2,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ประเภทรถ' } },
    }, {
      label: 'เจ้าของรถ',
      id: 'truckOwner',
      direction: 'column',
      type: 2,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'เจ้าของรถ' } },
    }, {
      label: 'พนักงานขับประจำ',
      id: 'truckDriver',
      direction: 'column',
      type: 15,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'พนักงานขับประจำ' } },
    }, {
      label: 'พนักงานขับรถ',
      id: 'shippingDriver',
      direction: 'column',
      type: 15,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'พนักงานขับรถ' } },
    }, {
      label: 'เวลาออก',
      id: 'startTime',
      direction: 'column',
      dataType: 'time',
      type: 2,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'เวลาออก' } },
    },
  ], [
    {
      label: 'ใบเบิกน้ำมัน',
      id: 'fillingOrdertext',
      type: 8,
      span: 16,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ใบเบิกน้ำมัน' } },
    }, {
      label: 'จ่ายเงินด้วย FleetCard',
      id: 'isPaidByFleetCard',
      type: 22,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', title: { text: 'จ่ายเงินด้วย FleetCard' } },
    }, {
      label: 'ปั๊มน้ำมัน *',
      id: 'gasstationCode',
      type: 12,
      span: 8,
      offset: 0,
      margin: '8px 0 12px',
      props: {
        padding: '8px 0', width: '100%', title: { text: 'ปั๊มน้ำมัน *' }, input: { margin: '0', padding: '4px 8px' },
      },
    }, {
      label: 'รหัสปั๊มน้ำมัน',
      id: 'gasstationName',
      type: 13,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'รหัสปั๊มน้ำมัน' } },
    }, {
      label: 'บริษัท',
      id: 'gasstationCompany',
      type: 13,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'บริษัท' } },
    }, {
      label: 'ค่าน้ำมันต่อลิตร (บาท)',
      id: 'pricePerLitre',
      dataType: 'float',
      type: 17.1,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ค่าน้ำมันต่อลิตร (บาท) *' } },
    }, {
      label: 'ปริมาณทั้งหมด (ลิตร)',
      id: 'totalAmount',
      dataType: 'float',
      type: 17.2,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ปริมาณทั้งหมด (ลิตร) *' } },
    }, {
      label: 'ค่าน้ำมันประมาณการ',
      id: 'totalPrice',
      type: 3,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ค่าน้ำมันทั้งหมด' } },
    }, {
      label: 'ประเภทเชื้อเพลิง *',
      id: 'fuelType',
      type: 21,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ประเภทเชื้อเพลิง' } },
    }, {
      label: 'อัตราเผาผลาญ (กิโลเมตร/ลิตร)',
      id: 'kmPerLitre',
      dataType: 'float',
      type: 17,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'อัตราเผาผลาญ (กิโลเมตร/ลิตร) *' } },
    }, {
      label: 'วันหมดอายุ',
      id: 'expiredDate',
      dataType: 'date',
      type: 7,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'วันหมดอายุ' } },
    }, {
      label: 'สถานะ',
      id: 'status',
      direction: 'column',
      // margin: '24px 0 0 0',
      type: 14,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'สถานะ' } },
    }, {
      label: 'ปริมาณที่เติมแล้ว',
      id: 'filledAmount',
      type: 13,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ปริมาณที่เติมแล้ว' } },
    }, {
      label: 'ค่าน้ำมันจริง',
      id: 'realPrice',
      type: 3,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ค่าน้ำมันทั้งหมด' } },
    }, {
      label: 'หักออกจากใบเบิกครั้งหน้า',
      id: 'totalAmount',
      type: 18,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'หักออกจากใบเบิกครั้งหน้า' } },
    }, {
      label: 'หักเบี้ยเลี้ยง',
      id: 'compensation',
      type: 18,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'หักเบี้ยเลี้ยง' } },
    }, {
      label: 'เหตุผล',
      id: 'specialReason',
      type: 23,
      span: 8,
      props: { padding: '8px 0', width: '100%', title: { text: 'เหตุผล' } },
    }, {
      label: 'กรอกเหตุผลอื่น ๆ',
      id: 'specialReasonOther',
      type: 24,
      span: 8,
      props: { padding: '8px 0', width: '100%', title: { text: 'กรอกเหตุผลอื่น ๆ' } },
    },
  ], [
    {
      label: 'หมายเหตุ',
      id: 'remark',
      span: 12,
      type: 11,
      props: { rows: 4 },
    },
  ], [
    {
      id: 'images',
      span: 24,
      type: 16,
      props: { margin: '8px 0' },
    },
  ],
]
